import { inject as o, onBeforeUnmount as a, computed as l } from "vue";
const t = Symbol("kori-form-field");
function f(n, d) {
  const e = o(t, null), i = !!e && !d.id && !d.label && e.claim();
  return i && a(() => e.release()), {
    id: l(() => i ? e.id.value : n.value),
    fieldDescribedBy: l(() => i ? e.describedBy.value : void 0),
    fieldInvalid: l(() => i ? e.invalid.value : !1)
  };
}
export {
  t as F,
  f as u
};
//# sourceMappingURL=formFieldContext-OfRFoILA.js.map
